import React, { useState, useEffect } from 'react'
import { Button, Col, Form, InputGroup, Modal, Row, Spinner } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { KTSVG } from 'src/_metronic/helpers'
import { createFindoc, downloadSKPP, getCustomer } from 'src/api/modules/findoc'
import Country from '../../component/DataCountry.json'
import CurrencyInput from 'react-currency-input-field'
import i18next from 'i18next'
import {getFile} from '../../../../api/modules/file'
import { Link, useNavigate } from 'react-router-dom'
import swal from 'sweetalert'
import BrowserCustomer from './admin/BrowseCustomer'
import { getFindocTypes, getIncoterm, getSalesArea, getSector, getTOP } from 'src/api/modules/getdatalist'
import { InputFile } from 'src/app/components/InputFile'
import BrowseBankKey from './admin/BrowseBankKey'
import Attachment from './admin/Attachment'
import Comment from './admin/Comment'

type Props = {
    hakAkses?: any
}

const AdminCreate: React.FC<Props> = ({
    hakAkses
}) => {
    const { t } = useTranslation()

    const [customerName, setCustomerName] = useState('')
    const [customerCode, setCustomerCode] = useState('')
    const [customerAddress, setCustomerAddress] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [emailCust, setEmailCust] = useState('')
    const [PICCust, setPICCust] = useState('')
    const [produsen, setProdusen] = useState('')
    const [namaJenisFindoc, setNamaJenisFindoc] = useState('')
    const [jenisFindoc, setJenisFindoc] = useState('')
    const [skbn, setSKBN] = useState('')
    const [noFindoc, setNoFindoc] = useState('')
    const [extnoFindoc, setExtNoFindoc] = useState('')
    const [approveState, setApproveState] = useState(false)
    const [status, setStatus] = useState(0)
    const [skpp, setSkpp] = useState('')
    const [sectorId, setSectorId] = useState<any>()
    const [downloadingSKPP, setDownloadingSKPP] = useState(false)
    const [SAP, setSAP] = useState(0)
    const [finDate, setFinDate] = useState<any>()
    const [tglFindoc, setTglFindoc] = useState<any>('')
    const [tanggalFindoc3, setTanggalFindoc3] = useState<any>()
    const [findocDesc, setFindocDesc] = useState('')
    const [negara, setNegara] = useState('')
    const [negaraDesc, setNegaraDesc] = useState('')
    const [bankKey, setBankKey] = useState('')
    const [bank, setBank] = useState('')
    const [showBank, setShowBank] = useState(false)
    const [nilai, setNilai] = useState<any>()
    const [TOP, setTOP] = useState('')
    const [fullTOP, setFullTOP] = useState([])
    const [showUpload, setShowUpload] = useState(false)
    const [sektordesc, setSektordesc] = useState('')
    const [dari, setFrom] = useState<any>('')
    const [berlaku, setBerlaku] = useState<any>('')
    const [incoterm, setIncoterm] = useState('')
    const [fullIncoterm, setFullIncoterm] = useState([])
    const [incoterm2, setIncoterm2] = useState('')
    const [uang, setUang] = useState<any>(0)
    const [batas, setBatas] = useState('')
    const [receiptDate, setReceiptDate] = useState<any>('')
    const [lastDateBol, setLastDateBol] = useState<any>('')
    const [presentationDate, setPresentationDate] = useState<any>('')
    const [openingDate, setOpeningDate] = useState<any>('')
    const [ship, setShip] = useState(false)
    const [customerID, setCustomerID] = useState('')
    const [titleCustomer, setTitleCustomer] = useState('')
    const [customer, setCustomer] = useState('')
    const [shipCust, setShipCust] = useState('')
    const [fullCustomer, setFullCustomer] = useState<any[]>([])
    const [numberURL, setNumberURL] = useState([])
    const [numberURL2, setNumberURL2] = useState([])
    const [allFile, setAllFiles] = useState<any[]>([])
    const [produsencode, setProdusenCode] = useState('')
    const [showCustomer, setShowCustomer] = useState(false)
    const [fileName, setFileName] = useState('')
    const [file, setFile] = useState('')
    const [keterangan, setKeterangan] = useState('')
    const [currency, setCurrency] = useState('IDR')
    const [dataProdusen, setDataProdusen] = useState<any[]>([])
    const [availableSectors, setAvailableSectors] = useState<any[]>([])
    const [disctribution, setDistribution] = useState('')
    const [fullSector, setFullSector] = useState<any[]>([])
    const [findocTypes, setFindocTypes] = useState<any[]>([])
    const [files, setFiles] = useState({file: null})
    const [attachments, setAttachments] = useState<any[]>([])

    const [comment, setComment] = useState<any[]>([])
    const [showComment, setShowComment] = useState(false)

    const language = i18next.language
    const lang = i18next.language
    const navigate = useNavigate()

    const separator = (value: any, state1: any, state2: any) => {
        const temp = value.split(',')
        state1(temp[0])
        state2(temp[1])
    }

    const textcondition = (type: any, data: any) => {
        let result = ''
        if (type == 'findoc') {
            switch (data) {
                case 'skbdn':
                    result = 'SKBDN'
                    break
                case 'bg':
                    result = 'Bank Guarantee'
                    break
                case 'lc':
                    result = 'Letter of Credit'
                    break
                default:
                    break
            }
        } else if (type == 'skbdn') {
            switch (data) {
                case '1':
                    result = 'At Sight'
                    break
                case '2':
                    result = 'Usance'
                    break
                default:
                    break
            }
        }
        return result
    }

    const getSKPP = async (no_skpp: any) => {
        setDownloadingSKPP(true)
        downloadSKPP(no_skpp)
            .then((res: any) => {
                window.open(`${res?.request?.responseURL}?token=${localStorage.getItem('token')}`)
            })
            .finally(() => setDownloadingSKPP(false))
            .catch((err: any) => {
                swal({
                    title: t(err?.response?.data?.message || 'Download Gagal, Silahkan Hubungi Admin!'),
                    icon: 'error',
                })
            })
    }

    const ambilAttachment = async (id: any) => {
        const res = await getFile('findoc', id, localStorage.getItem('credential')!)
        handleShowAttachment(res.data.data)
    }

    const handleShowAttachment = (data: any) => {
        let tmp: any[] = []
        let idUser = localStorage?.getItem('user-id')
        data.forEach((item: any) => {
        if (item.private) {
            if (hakAkses?.attachment) {
            return tmp.push(item)
            } else if (idUser == item.user_id) {
            return tmp.push(item)
            } else {
            }
        } else {
            return tmp.push(item)
        }
        })
        setAllFiles(tmp)
    }

    const handleCustomer = async () => {
        await getCustomer(produsencode, '', '', '').then((res: any) => {
          setFullCustomer(res.data.data.data)
          setNumberURL(res.data.data.links)
          setShowCustomer(true)
        })
    }

    const chooseCustomer = (data: any) => {
        let custName = [
            data?.title,
            data?.name
        ].filter((x: any) => x).join(". ")

        setCustomer(custName)
        setCustomerName(custName)
        setCustomerCode(data?.customer_code)
        setCustomerAddress(data?.address?.street1)
        setCustomerID(data?.id)
        setPhoneNumber(data?.address?.no_telp)
        setEmailCust(data?.user?.email)
        setPICCust(data?.name4)
        setAvailableSectors(data?.user?.sectors)
        setShowCustomer(false)
    }

    const chooseBankKey = (data: any) => {
        setBankKey(data?.bank_key)
        setBank(data?.bank_name)
        setShowBank(false)
    }

    const addAttachment = async (data: any) => {
        let _files = [...attachments]
        _files.push(data)
        setAttachments(_files)
    }

    const removeAttachment = (index: number) => {
        let _files = [...attachments]
        _files.splice(index, 1)
        setAttachments(_files)
    }

    useEffect(() => {
        const parseIncoterms = async () => {
            await getIncoterm().then((res: any) => {
                setFullIncoterm(res.data.data)
            })
        }
        const parseTop = async () => {
            await getTOP().then((res: any) => {
                setFullTOP(res.data.data)
            })
        }

        parseIncoterms();
        parseTop();
    }, [])
    
    useEffect(() => {
        const parseProdusen = async () => {
            await getSalesArea(customerCode).then((res: any) => {
                setDataProdusen(res.data.data)
            })
        }
        
        parseProdusen()
    }, [customerCode])

    useEffect(() => {
        const parseSectors =  async () => {
            await getSector(disctribution).then((res: any) => {
                const temp: any[] = res.data.data
                setFullSector(temp.filter((item: any) => availableSectors?.includes(item.id+'')))
            })
        }

        parseSectors()
    }, [disctribution])

    const addComment = (data: any) => {
        let _comments = [...comment]
        _comments.push(data)
        setComment(_comments)
    }

    const [btnLoading, setBtnLoading] = useState(false)
    const create = async () => {
        swal({
            title: `${t('Are you sure?')}`,
            icon: 'warning',
            buttons: [`${t('Tidak')}`, `${t('Ya')}`],
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                setBtnLoading(true)
                let file = files.file
                let formdata = new FormData()

                if(file){
                    formdata.append('file', file!)
                }
                formdata.append('sales_org_code', produsen!)
                formdata.append('findoc_type', jenisFindoc!)
                if (jenisFindoc == 'skbdn') formdata.append('type_skbdn', skbn!)

                formdata.append('no_findoc', noFindoc!)
                formdata.append('num_findoc', extnoFindoc!)
                if(finDate) {
                    formdata.append('tgl_findoc', finDate!)
                }
                formdata.append('findoc_desc', findocDesc!)
                formdata.append('negara', negara!)
                formdata.append('negara_desc', negaraDesc!)
                formdata.append('bank_name', bank!)
                formdata.append('bank_key', bankKey!)
                if(nilai){
                    formdata.append('nilai', parseFloat(nilai) + "")
                }
                formdata.append('top_id', TOP)
                if(sectorId){
                    formdata.append('sector_id', sectorId)
                }
                formdata.append('validity_date_from', dari)
                formdata.append('validity_date_to', berlaku)
                formdata.append('incoterm_id', incoterm)
                formdata.append('incoterm2_id', incoterm2)
                formdata.append('allowance', uang)
                formdata.append('delivery_deadline', batas)
                formdata.append('receipt_date', receiptDate)
                formdata.append('last_date_bol', lastDateBol)
                formdata.append('presentation_date', presentationDate)
                formdata.append('opening_date', openingDate)
                formdata.append('customer_ship_to', customerID)
                formdata.append('customer_code', customerCode)
                formdata.append('description', keterangan)
                formdata.append('credentials', localStorage.getItem('credential')!)
                formdata.append('attachment', JSON.stringify(allFile))
                formdata.append('comment', JSON.stringify(comment))
                formdata.append('currency', currency)

                await createFindoc(formdata)
                .then((response: any) => {
                    if (!response.data.error)
                    swal({
                        title: `${t('Findoc Created Successfully')}`,
                        icon: 'success',
                    }).then(() => {
                        navigate('/financial')
                    })
                    else
                    swal({
                        title: `${t('Error')}`,
                        icon: 'error',
                    })
                })
                .catch(function (error: any) {
                    if (error.response) {
                    swal({
                        title: `${t(error.response.data.message)}`,
                        icon: 'error',
                    })
                    }
                })
                .finally(() => {
                    setBtnLoading(false)
                })
            }
        });
    }

    useEffect(() => {
        const parseFindocTypes = async () => {
            await getFindocTypes(sectorId).then((res: any) => {
                setFindocTypes(res.data.data)
            })
        }

        parseFindocTypes()
    }, [sectorId])

    return (
        <>
            <div className='card mb-4'>
                <div className='card-body'>
                    <Row className='rounded'>
                        <Col md={6}>
                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>{t('Customer Number')} <span className='text-danger'>*</span></Form.Label>
                                <div className='d-flex' style={{ width: '70%' }}>
                                    <Form.Control
                                        className='me-1 w-100'
                                        aria-label='Default example'
                                        value={customerCode}
                                        disabled
                                    />
                                    <Button
                                        className='btn btn-primary d-flex justify-content-center align-items-center'
                                        data-bs-toggle='tooltip'
                                        data-bs-placement='top'
                                        data-bs-trigger='hover'
                                        title={t('telusuri')}
                                        onClick={() => setShowCustomer(true)}
                                    >
                                        <KTSVG
                                            path='/media/icons/duotune/browse.svg'
                                            className='svg-icon-3 ms-2'
                                        />
                                    </Button>

                                    <BrowserCustomer show={showCustomer} setShow={setShowCustomer} onChoose={chooseCustomer}/>
                                </div>
                            </div>
                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>{t('Customer Name')}</Form.Label>
                                <Form.Control
                                    aria-label='Default example'
                                    style={{ width: '70%' }}
                                    value={customerName}
                                    disabled
                                />
                            </div>
                            <div className='d-flex justify-content-between align-items-center'>
                                <Form.Label className='me-2'>{t('Address')}</Form.Label>
                                <Form.Control
                                    aria-label='Default example'
                                    as='textarea'
                                    style={{ width: '70%', minHeight: '40px', height: 'auto' }}
                                    value={customerAddress}
                                    disabled
                                />
                            </div>
                        </Col>

                        <Col md={6}>
                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>{t('Phone Number')}</Form.Label>
                                <Form.Control
                                    aria-label='Default example'
                                    style={{ width: '70%' }}
                                    value={phoneNumber}
                                    disabled
                                />
                            </div>
                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>{t('Email')}</Form.Label>
                                <Form.Control
                                    aria-label='Default example'
                                    style={{ width: '70%' }}
                                    value={emailCust}
                                    disabled
                                />
                            </div>
                            <div className='d-flex justify-content-between align-items-center'>
                                <Form.Label className='me-2'>{t('PIC Customer')}</Form.Label>
                                <Form.Control
                                    aria-label='Default example'
                                    style={{ width: '70%' }}
                                    value={PICCust}
                                    disabled
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>

            <div className='card'>
                <div className='card-body'>
                    <Row>
                        <Col md={6}>
                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>Sales Org <span className='text-danger'>*</span></Form.Label>
                                <Form.Select
                                    aria-label='Default select example'
                                    style={{width: '70%'}}
                                    onChange={(e: any) => {
                                        let _value = e?.target?.value?.split("~#~")
                                        setProdusen(_value[0])
                                        setDistribution(_value[1])
                                    }}
                                >
                                    <option>{t('pilih')}</option>
                                    {dataProdusen.map((item: any, index: number) => {
                                        return (
                                            <option key={item?.sales_org ?? index} value={[
                                                item.sales_org,
                                                item.distribution_channel
                                            ].join("~#~")}>
                                            {item.produsen?.name}
                                            </option>
                                        )
                                    })}
                                </Form.Select>
                            </div>
                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>{t('Findoc Type')} <span className='text-danger'>*</span></Form.Label>
                                <Form.Select
                                    aria-label='Default select example'
                                    style={{width: '70%'}}
                                    onChange={(e: any) => {
                                        console.log(e?.target?.value)
                                        setJenisFindoc(e.target.value)
                                        if (e.target.value == 'lc') {
                                            setCurrency('USD')
                                        }else{
                                            setCurrency('IDR')
                                        }
                                    }
                                }>
                                    <option>{t('pilih')}</option>
                                    {findocTypes.map((item: any, index: number) => {
                                        return (
                                            <option key={item?.code ?? index} value={item.code}>
                                                {item?.name}
                                            </option>
                                        )
                                    })}
                                </Form.Select>
                            </div>
                            {jenisFindoc == 'skbdn' ? (
                                <div className='d-flex justify-content-between align-items-center mb-4'>
                                    <Form.Label className='me-2'>{t('Skbdn Type')}</Form.Label>
                                    <Form.Select
                                        aria-label='Default select example'
                                        style={{width: '70%'}}
                                        onChange={(e: any) => setSKBN(e.target.value)}
                                        >
                                        <option selected value={''}>
                                            {t('pilih')} {t('Skbdn Type')}
                                        </option>
                                        <option value='1'>At Sight</option>
                                        <option value='2'>Usance</option>
                                    </Form.Select>
                                </div>
                            ) : (
                                ''
                            )}

                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>
                                    {t('Findoc Number')}
                                </Form.Label>
                                <Form.Control
                                    type='text'
                                    placeholder={t('Enter Findoc Num')}
                                    style={{ width: '70%' }}
                                    onChange={(e: any) => setNoFindoc(e?.target?.value)}
                                />
                            </div>
                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>
                                    {t('Ext Findoc Number')}
                                    <span className='text-danger'>
                                        *
                                    </span>
                                </Form.Label>
                                <Form.Control
                                    type='text'
                                    placeholder={t('Ext Findoc Number')}
                                    style={{ width: '70%' }}
                                    onChange={(e: any) => setExtNoFindoc(e.target.value)}
                                />
                            </div>
                            <div className='d-flex justify-content-between align-items-center mb-4 w-100'>
                                <Form.Label className='' style={{ width: (skpp && (sectorId == 2) && (jenisFindoc == 'df')) ? '35%' : '30%' }}>
                                    {t('no skkp/lecto')}
                                </Form.Label>
                                <Form.Control
                                    type='text'
                                    defaultValue={skpp == null || skpp == 'null' ? '' : skpp}
                                    style={{ width: '70%' }}
                                />
                                {(skpp && (sectorId == 2) && (jenisFindoc == 'df')) && (
                                    <button
                                        className='btn btn-icon btn-bg-light btn-color-primary btn-active-primary btn-active-color-white ms-1 px-2'
                                        data-bs-toggle='tooltip'
                                        data-bs-placement='top'
                                        data-bs-trigger='hover'
                                        title={t('unduh')}
                                        disabled={downloadingSKPP}
                                        onClick={() => getSKPP(skpp)}
                                    >
                                        <KTSVG
                                            path='/media/icons/duotune/arrow-down-square-fill.svg'
                                            className='svg-icon-3'
                                        />
                                    </button>
                                )}
                            </div>
                            {SAP == null || SAP == 0 ? (
                                ''
                            ) : (
                                <div className='d-flex justify-content-between align-items-center mb-4'>
                                    <Form.Label className='me-2'>{t('SAP Number')}</Form.Label>
                                    <Form.Control
                                        type='text'
                                        // placeholder={t("Enter SAP Number")}
                                        style={{ width: '70%' }}
                                        value={SAP}
                                        disabled
                                    />
                                </div>
                            )}
                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>
                                    {t('Tanggal Findoc')}
                                    <span className='text-danger'>
                                        *
                                    </span>
                                </Form.Label>
                                <div style={{ width: '70%' }}>
                                    <input
                                        type='date'
                                        defaultValue={finDate}
                                        onChange={(date: any) => {
                                            setFinDate(date.target.value)
                                            setTglFindoc(date.target.value)
                                        }}
                                        className='form-control'
                                    />
                                </div>
                            </div>

                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>
                                    {t('Findoc Desc')}
                                    <span className='text-danger'>
                                        *
                                    </span>
                                </Form.Label>
                                <Form.Control
                                    type='text'
                                    placeholder={t("Enter Findoc Desc")}
                                    defaultValue={findocDesc}
                                    style={{ width: '70%' }}
                                    onChange={(e: any) => setFindocDesc(e.target.value)}
                                />
                            </div>
                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>
                                    {t('Bank Country')}
                                    <span  className='text-danger'>
                                        *
                                    </span>
                                </Form.Label>
                                <Form.Select
                                    placeholder={t('Bank Country')}
                                    style={{ width: '70%' }}
                                    onChange={(e: any) => {
                                        separator(e.target.value, setNegara, setNegaraDesc)
                                        setBankKey('')
                                        setBank('')
                                    }}
                                >
                                    <>
                                        <option>
                                            {t('pilih')} {t('Bank Country')}
                                        </option>
                                        {Country.dataCountry.map((item: any) => {
                                            return (
                                                <>
                                                    {negaraDesc == item.name ? (
                                                        <option selected value={item.code + ',' + item.name}>
                                                            {item.name}
                                                        </option>
                                                    ) : (
                                                        <option value={item.code + ',' + item.name}>
                                                            {item.name}
                                                        </option>
                                                    )}
                                                </>
                                            )
                                        })}
                                    </>
                                </Form.Select>
                            </div>
                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>
                                    Bank Key
                                    <span  className='text-danger'>
                                        *
                                    </span>
                                </Form.Label>
                                <div className='d-flex' style={{ width: '70%' }}>
                                    <Form.Control
                                        type='text'
                                        className='me-1 w-100'
                                        disabled
                                        placeholder={'Bank Key'}
                                        value={bank}
                                    />
                                    <Button
                                        className='btn btn-primary d-flex justify-content-center align-items-center'
                                        data-bs-toggle='tooltip'
                                        data-bs-placement='top'
                                        data-bs-trigger='hover'
                                        title={t('telusuri')}
                                        onClick={() => setShowBank(true)}
                                    >
                                        <KTSVG
                                            path='/media/icons/duotune/browse.svg'
                                            className='svg-icon-3 ms-2'
                                        />
                                    </Button>

                                    <BrowseBankKey show={showBank} setShow={setShowBank} country={negara} onChoose={chooseBankKey}/>
                                </div>
                            </div>

                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label style={{ width: '30%' }}>
                                    {t('Finance doc. value')}
                                    <span className='text-danger'>
                                        *
                                    </span>
                                </Form.Label>
                                <CurrencyInput
                                    style={{ width: '70%' }}
                                    key={i18next.language}
                                    className='form-control'
                                    placeholder={approveState ? t('Finance doc. value') : ''}
                                    defaultValue={nilai}
                                    decimalSeparator={i18next.language === 'en' ? '.' : ','}
                                    groupSeparator={i18next.language === 'en' ? ',' : '.'}
                                    onValueChange={(e: any) => {
                                        setNilai(e?.replace(/,/g, '.'))
                                    }}
                                    decimalsLimit={2}
                                />
                            </div>

                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label style={{ width: '30%' }}>
                                    {t('Terms of Payment')}
                                    <span
                                        hidden={approveState || status == 5 ? false : true}
                                        className='text-danger'
                                    >
                                        *
                                    </span>
                                </Form.Label>
                                <Form.Select
                                    aria-label='Default select example'
                                    style={{ width: '70%' }}
                                    onChange={(e: any) => setTOP(e.target.value)}
                                >
                                    {fullTOP.map((item: any) => {
                                        return (
                                            <>
                                                {TOP == item.code ? (
                                                    <option selected value={item.code}>
                                                        {item.top_desc}
                                                    </option>
                                                ) : (
                                                    <option value={item.code}>{item.top_desc}</option>
                                                )}
                                            </>
                                        )
                                    })}
                                </Form.Select>
                            </div>
                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>{t('order-lampiran')}</Form.Label>
                                <Button
                                    style={{ width: '70%' }}
                                    variant='primary'
                                    onClick={() => {
                                        setShowUpload(true)
                                    }}
                                >
                                    <i className='fas fa-file'></i> {t('order-lampiran')}
                                </Button>

                                <Attachment show={showUpload} setShow={setShowUpload} allFiles={attachments} addFile={addAttachment} removeFile={removeAttachment}/>
                            </div>

                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>{t('Comment')}</Form.Label>
                                <Button
                                    style={{ width: '70%' }}
                                    variant='primary'
                                    onClick={() => {
                                        setShowComment(true)
                                    }}
                                >
                                    <i className='fas fa-comment'></i> {t('Comment')}
                                </Button>

                                <Comment show={showComment} setShow={setShowComment} comments={comment} addComment={addComment}/>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>{t('sub-order-sektor')} <span className='text-danger'>*</span></Form.Label>
                                <Form.Select
                                    aria-label='Default select example'
                                    id='sektor'
                                    style={{width: '70%'}}
                                    onChange={(e: any) => {
                                        let _value = e?.target?.value?.split("~#~");
                                        setSectorId(_value[0])
                                        setSektordesc(_value[1])
                                    }}
                                >
                                    <option>{t('pilih')}</option>
                                    {fullSector.map((item: any, index: number) => {
                                        return (
                                            <option key={item?.sales_org ?? index} value={[
                                                item.id,
                                                item.name
                                            ].join("~#~")}>
                                            {item?.name}
                                            </option>
                                        )
                                    })}
                                </Form.Select>
                            </div>

                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>{t('mataUang')}</Form.Label>
                                <Form.Control type='text' disabled value={currency} style={{ width: '70%' }} />
                            </div>
                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>
                                    {t('Valid Start Date')}
                                    <span className='text-danger'>
                                        *
                                    </span>
                                </Form.Label>
                                <Form.Control
                                    type='Date'
                                    defaultValue={dari}
                                    style={{ width: '70%' }}
                                    onChange={(e: any) => setFrom(e.target.value)}
                                />
                            </div>
                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>
                                    {t('valid End Date')}
                                    <span className='text-danger'>
                                        *
                                    </span>
                                </Form.Label>
                                <Form.Control
                                    type='Date'
                                    defaultValue={berlaku}
                                    style={{ width: '70%' }}
                                    onChange={(e: any) => setBerlaku(e.target.value)}
                                />
                            </div>
                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>
                                    Incoterm
                                    <span className='text-danger'>
                                        *
                                    </span>
                                </Form.Label>
                                <Form.Select
                                    aria-label='Default select example'
                                    style={{ width: '70%' }}
                                    onChange={(e: any) => setIncoterm(e.target.value)}
                                >
                                    <option value=''>{ t('pilih') } { t('sub-order-incoterm') }</option>
                                    {fullIncoterm.map((item: any) => {
                                        return (
                                            <>
                                                {item.id == incoterm ? (
                                                    <option selected value={item.id}>
                                                        {item.code}
                                                    </option>
                                                ) : (
                                                    <option value={item.id}>{item.code}</option>
                                                )}
                                            </>
                                        )
                                    })}
                                </Form.Select>
                            </div>
                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>
                                    Incoterm 2
                                    <span className='text-danger'  >
                                        *
                                    </span>
                                </Form.Label>
                                <Form.Control
                                    style={{ width: '70%' }}
                                    defaultValue={incoterm2}
                                    placeholder='Incoterm 2'
                                    onChange={(e: any) => setIncoterm2(e.target.value)}
                                />
                            </div>
                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>{t('uangSaku')}</Form.Label>
                                <InputGroup style={{ width: '70%' }}>
                                    <CurrencyInput
                                        className='form-control form-control-sm'
                                        value={
                                            i18next.language === 'en'
                                                ? uang?.toLocaleString('en', { maximumFractionDigits: 2 })
                                                : uang?.toLocaleString('id', { maximumFractionDigits: 2 })
                                        }
                                        placeholder={t('uangSaku')}
                                        decimalSeparator={language === 'en' ? '.' : ','}
                                        groupSeparator={language === 'en' ? ',' : '.'}
                                        onValueChange={(value: any) => {
                                            let _value = value?.replace(/,/g, '.')
                                            if (_value > 100) _value = 100
                                            setUang(_value)
                                        }}
                                        max={100}
                                        decimalsLimit={2}
                                    />
                                    <InputGroup.Text id='basic-addon2'>%</InputGroup.Text>
                                </InputGroup>
                            </div>
                            
                            <div className='d-flex justify-content-between align-items-center mb-4 w-100'>
                                <Form.Label className='' style={{ width: '30%' }}>
                                    {t('Latest Shipment Date')}
                                    <span className='text-danger'>
                                        *
                                    </span>
                                </Form.Label>
                                <Form.Control
                                    type='date'
                                    defaultValue={batas}
                                    style={{ width: '70%' }}
                                    onChange={(e: any) => setBatas(e.target.value)}
                                />
                            </div>

                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>{t('receipt_date')}</Form.Label>
                                <input
                                    type='date'
                                    defaultValue={receiptDate}
                                    style={{ width: '70%' }}
                                    onChange={(date: any) => {
                                        setReceiptDate(date.target.value)
                                    }}
                                    className='form-control'
                                />
                            </div>

                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>{t('last_date_bol')}</Form.Label>
                                <Form.Control
                                    type='date'
                                    defaultValue={lastDateBol}
                                    onChange={(date: any) => {
                                        setLastDateBol(date.target.value)
                                    }}
                                    style={{ width: '70%' }}
                                    className='form-control'
                                />
                            </div>

                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label style={{ width: '30%' }}>{t('presentation_date')}</Form.Label>
                                <input
                                    type='date'
                                    defaultValue={presentationDate}
                                    onChange={(date: any) => {
                                        setPresentationDate(date.target.value)
                                    }}
                                    style={{ width: '70%' }}
                                    className='form-control'
                                />
                            </div>

                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>{t('opening_date')}</Form.Label>
                                <input
                                    type='date'
                                    defaultValue={openingDate}
                                    onChange={(date: any) => {
                                        setOpeningDate(date.target.value)
                                    }}
                                    style={{ width: '70%' }}
                                    className='form-control'
                                />
                            </div>

                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>{t('Ship-to Party')} <span className='text-danger'>
                                        *
                                    </span></Form.Label>
                                <Form.Check
                                    reverse
                                    className='mt-5 mb-2'
                                    type='checkbox'
                                    id='ckbox-ship'
                                    defaultChecked={ship}
                                    onClick={() => setShip(!ship)}
                                />
                            </div>
                            {ship ? (
                                <div className='d-flex justify-content-between align-items-center mb-4'>
                                    <Form.Label className='me-2'></Form.Label>
                                    <div className='d-flex' style={{ width: '70%' }}>
                                        <Form.Control
                                            type='text'
                                            size='sm'
                                            className='w-100'
                                            placeholder={'Search' + ' ' + t('Customer')}
                                            disabled
                                            value={
                                                customerID == ''
                                                        ? ''
                                                        : customerID + ' - ' + titleCustomer + ' ' + customerName
                                            }
                                            style={{ width: '70%' }}
                                        />
                                        <Button
                                            className='btn btn-primary d-flex justify-content-center align-items-center ms-1'
                                            data-bs-toggle='tooltip'
                                            data-bs-placement='top'
                                            data-bs-trigger='hover'
                                            title={t('telusuri')}
                                            onClick={() => handleCustomer()}
                                        >
                                            <KTSVG
                                                path='/media/icons/duotune/browse.svg'
                                                className='svg-icon-3 ms-2'
                                            />
                                        </Button>
                                    </div>
                                </div>
                            ) : (
                                <></>
                            )}

                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>File {t('Findoc')} <span className='text-danger'>
                                        *
                                    </span></Form.Label>
                                <div
                                    style={{ width: '70%', height: '40px' }}
                                >
                                    <InputFile
                                        setFileName={(_: string) => {}}
                                        setFiles={setFiles}
                                        isBase64={false}
                                    />
                                </div>
                            </div>

                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <Form.Label className='me-2'>{t('Keterangan')}</Form.Label>
                                <Form.Control
                                    as='textarea'
                                    defaultValue={
                                        keterangan == null || keterangan == 'null' ? '' : keterangan
                                    }
                                    style={{ width: '70%', height: '40px' }}
                                    onChange={(e: any) => setKeterangan(e.target.value)}
                                />
                            </div>
                        </Col>
                    </Row>

                    <hr/>

                    <div className='d-flex align-items-center justify-content-end mt-5'>
                        <Link to={'/financial'}>
                            <button className='btn btn-secondary me-2'>
                                <i className='fas fa-chevron-left'></i> {t('order-kembali')}
                            </button>
                        </Link>
                         <button
                            className='btn btn-primary'
                            onClick={() => create()}
                        >
                            <i className='fas fa-save'></i> {t('Save')}
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AdminCreate